/**
 * The analytics consent cookie.
 *
 * The preference lives in `User.dataOptOut`, but the root layout renders on
 * public pages where there is no signed-in user to ask about, and the PostHog
 * bootstrap runs before any React code. A cookie is the only thing both can
 * read synchronously, with no network call.
 *
 * NOT httpOnly: `instrumentation-client.ts` reads it from `document.cookie`.
 * Copying the auth cookies' `httpOnly: true` would break the PostHog gate
 * silently, leaving the Meta Pixel gate working and no error anywhere.
 */
export const ANALYTICS_OPTOUT_COOKIE = 'leva_analytics_optout';

/** Opted out. Any other value, or no cookie, means no preference expressed. */
const OPTED_OUT = '1';

/** The value to store when opting out. Clearing the cookie means opting in. */
export const ANALYTICS_OPTOUT_VALUE = OPTED_OUT;

/** A year. The preference deliberately outlives the session. */
export const ANALYTICS_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export function analyticsOptOutFromCookieValue(value: string | undefined): boolean {
  return value === OPTED_OUT;
}
